/**
 * MajesticPure - Shop Pay GA4 click tracking
 * Standalone file. Does not modify theme.js or any existing JS file.
 *
 * GA4 Measurement ID: G-7JSHRERHBZ
 * Event: shop_pay_click
 */
(function () {
  'use strict';

  var GA4_ID = 'G-7JSHRERHBZ';
  var EVENT_NAME = 'shop_pay_click';
  var GTAG_SRC = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA4_ID);
  var initialized = false;

  function initGA4() {
    if (initialized) return;
    initialized = true;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    // Load Google tag only if this standalone tracker has not already loaded it.
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"][src*="' + GA4_ID + '"]')) {
      var script = document.createElement('script');
      script.async = true;
      script.src = GTAG_SRC;
      document.head.appendChild(script);
    }

    // Do not create a second page_view just for this tracker.
    window.gtag('js', new Date());
    window.gtag('config', GA4_ID, {
      send_page_view: false
    });
  }

  function getFormFromPath(path) {
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (node && node.nodeType === 1 && node.tagName === 'FORM') {
        return node;
      }
      if (node && node.closest) {
        var form = node.closest('form');
        if (form) return form;
      }
    }
    return null;
  }

  function getShopPayElement(path) {
    var selectors = [
      'shopify-accelerated-checkout',
      'shopify-buy-it-now-button',
      '[data-shopify="payment-button"]',
      '.shopify-payment-button'
    ];

    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || node.nodeType !== 1) continue;

      for (var j = 0; j < selectors.length; j++) {
        if (node.matches && node.matches(selectors[j])) {
          return node;
        }
      }
    }

    return null;
  }

  function getVariantId(form) {
    if (!form) return '';

    var input = form.querySelector('input[name="id"], input[name="variant_id"]');
    if (input && input.value) return input.value;

    return '';
  }

  function getQuantity(form) {
    if (!form) return 1;

    var input = form.querySelector('input[name="quantity"]');
    var quantity = input ? parseInt(input.value, 10) : 1;

    return quantity > 0 ? quantity : 1;
  }

  function getProductData(form) {
    var data = {
      product_id: '',
      product_name: '',
      variant_id: getVariantId(form),
      quantity: getQuantity(form),
      value: undefined,
      currency: 'USD'
    };

    // Shopify's analytics metadata is available on many storefront product pages.
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta) {
        if (meta.product) {
          data.product_id = String(meta.product.id || '');
          data.product_name = meta.product.title || '';
        }
        if (meta.selectedVariantId) {
          data.variant_id = String(meta.selectedVariantId);
        }
      }
    } catch (e) {}

    // Fallbacks from the current product page.
    if (!data.product_name) {
      var titleEl = document.querySelector(
        '.product__title, .product__title h1, [data-product-title], h1.product-title'
      );
      if (titleEl) data.product_name = titleEl.textContent.trim();
    }

    if (!data.product_id) {
      var productForm = form && form.closest('[data-product-id]');
      if (productForm) data.product_id = productForm.getAttribute('data-product-id') || '';
    }

    // Currency from Shopify's global object or document language/currency metadata.
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        data.currency = window.Shopify.currency.active;
      }
    } catch (e) {}

    return data;
  }

  function isShopPayClick(element) {
    if (!element) return false;

    var tag = (element.tagName || '').toLowerCase();

    // Shopify's accelerated checkout host is the primary Shop Pay button
    // shown in the screenshot / dynamic checkout area.
    if (tag === 'shopify-accelerated-checkout' || tag === 'shopify-buy-it-now-button') {
      return true;
    }

    // Legacy dynamic checkout markup.
    var text = (element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (text.indexOf('buy with shop') !== -1 || text.indexOf('shop pay') !== -1) {
      return true;
    }

    // If the actual click path contains a Shop Pay button inside the host.
    return false;
  }

  function trackShopPayClick(event) {
    var path = typeof event.composedPath === 'function'
      ? event.composedPath()
      : [event.target];

    var paymentElement = getShopPayElement(path);
    if (!paymentElement || !isShopPayClick(paymentElement)) return;

    // Prevent duplicate tracking when the browser emits more than one click
    // event through nested Shopify payment-button elements.
    var now = Date.now();
    if (window.__majesticPureLastShopPayClick &&
        now - window.__majesticPureLastShopPayClick < 700) {
      return;
    }
    window.__majesticPureLastShopPayClick = now;

    initGA4();

    var form = getFormFromPath(path);
    var product = getProductData(form);

    var params = {
      shop_pay_source: 'dynamic_checkout',
      shop_pay_button: 'buy_with_shop',
      page_url: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title,
      page_template: document.body && document.body.dataset
        ? (document.body.dataset.template || '')
        : '',
      product_id: product.product_id,
      product_name: product.product_name,
      variant_id: product.variant_id,
      quantity: product.quantity,
      currency: product.currency
    };

    window.gtag('event', EVENT_NAME, params);

    // Useful for browser-console testing.
    try {
      window.dispatchEvent(new CustomEvent('majesticpure:shop_pay_click', {
        detail: params
      }));
    } catch (e) {}
  }

  // Capture clicks from Shopify's custom element and its Shadow DOM.
  document.addEventListener('click', trackShopPayClick, true);

  // Shopify can render/re-render the accelerated checkout after page load.
  // Event delegation means no per-element initialization is required.
  initGA4();
})();
